import { useSeo } from "@/lib/useSeo";
import { useApi } from "@/lib/api";
import { PageHero, SectionHeading } from "@/components/site/kit";
import { CtaBanner, ProcessTimeline, ServicesGrid, TechStrip } from "@/components/site/Sections";

export default function Services() {
  useSeo({ title: "Services", description: "Custom software, mobile apps, web applications, CRM, AI & WhatsApp automation and maintenance services in India." });
  const { data: c } = useApi("/content/homepage");
  return (
    <>
      <PageHero badge="Services" title="Software services built" highlight="around your business" subtitle="Whether you need a mobile app, a CRM or a complete platform, our team handles strategy, design, development and support under one roof." />
      <section className="section bg-page">
        <div className="container-x"><ServicesGrid detailed /></div>
      </section>
      <section className="section bg-white">
        <div className="container-x">
          <SectionHeading badge="How we work" title="A proven process," highlight="zero surprises" center />
          <ProcessTimeline steps={c?.process || []} />
        </div>
      </section>
      <section className="border-y border-line bg-page py-14">
        <div className="container-x"><TechStrip items={c?.technologies || []} /></div>
      </section>
      <section className="section bg-white">
        <div className="container-x"><CtaBanner {...(c?.cta_banner || {})} /></div>
      </section>
    </>
  );
}
